export const envs = Object.freeze({
  Sandbox: 'SANDBOX',
  Production: 'PRODUCTION'
})
